<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px">{{ i18nValues["palletSearch"] }}</h4>
      </div>

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form>
          <div class="filters-wrapper">
            <div class="filters-row">
              <!-- search by Status -->
              <el-form-item :label="i18nValues['status']" prop="status">
                <el-select
                  v-model="filter.status"
                  :placeholder="i18nValues['status']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in optionsStatus"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search by Dispatch Type -->
              <el-form-item
                :label="i18nValues['dispatchType']"
                prop="dispatchType"
              >
                <el-select
                  v-model="filter.dispatchType"
                  :placeholder="i18nValues['dispatchType']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in optionsDispatch"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search by Id -->
              <el-form-item :label="i18nValues['code']" prop="id">
                <el-input
                  v-model="filter.id"
                  :placeholder="i18nValues['code']"
                ></el-input>
              </el-form-item>

              <!-- search by Name -->
              <el-form-item label="Brand" prop="product">
                <el-select
                  v-model="filter.name"
                  filterable
                  :placeholder="i18nValues['brand-variety']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="product in ProductList"
                    :key="product.id"
                    :label="product.brand + ' - ' + product.name"
                    :value="product.name"
                  >
                    <span
                      v-html="
                        `<strong>${product.brand}</strong> - ${product.name}`
                      "
                    ></span>
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- search by Batch -->
              <el-form-item :label="i18nValues['batch']" prop="batch">
                <el-input
                  v-model="filter.batch"
                  :placeholder="i18nValues['batch']"
                  type="text"
                ></el-input>
              </el-form-item>

              <!-- pass Date for java -->
              <el-form-item :label="i18nValues['date']" prop="creationDate">
                <div class="input-group">
                  <el-date-picker
                    type="date"
                    class="calendar"
                    format="dd/MM/yyyy"
                    v-model="filter.creationDate"
                    :placeholder="i18nValues['date']"
                    :clearable="true"
                  >
                  </el-date-picker>
                  <span class="input-group-addon primary el-input__suffix icon">
                    <span class="arrow"></span>
                    <i class="fa fa-calendar-alt"></i>
                  </span>
                </div>
              </el-form-item>

              <!-- Crop Type -->
              <el-form-item :label="i18nValues['crop']" prop="cropType">
                <el-select
                  v-model="filter.cropType"
                  :placeholder="i18nValues['crop']"
                >
                  <el-option :value="null"></el-option>
                  <el-option
                    v-for="item in variedades"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- Search Pallets -->
              <el-button
                icon="fas fa-search"
                :loading="loading != 0"
                size="small"
                class="btn-primary"
                aling="right"
                @click="retrievePalletsBySearch()"
              >
                {{ i18nValues["search"] }}
              </el-button>

              <!-- Export Pallets -->
              <el-button
                icon="fas fa-file-excel"
                size="small"
                class="btn-primary"
                @click="exportExcel()"
              >
                {{ i18nValues["export"] }}
              </el-button>
            </div>
          </div>

          <!-- table -->
          <el-form-item prop="pallets">
            <div class="full-width table-container" v-loading="loading" style="margin:0 auto;padding:20px;">
              <el-table
                id="PalletsTable"
                :data="PalletsSubList"
                @sort-change="handleSortChange"
                :default-sort="tableDefaultSort"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                class="table table-hover"
                stripe
                align="center"
                :empty-text="hasAttemptedLoad ? i18nValues['noDataAvailable'] : ''"
                :tree-props="{ children: 'items' }"
              >
                <!-- Brand -->
                <el-table-column
                  prop="product.brand"
                  label="Brand"
                  width="125"
                  align="left"
                  sortable
                ></el-table-column>

                <!-- LableBatch -->
                <el-table-column
                  prop="label.id"
                  :label="i18nValues['label']"
                  width="105"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Loading Order -->
                <el-table-column
                  :label="i18nValues['order']"
                  width="85"
                  align="right"
                  prop="loadingOrder.id"
                  sortable
                ></el-table-column>

                <!-- Status -->
                <el-table-column
                  prop="status"
                  :label="i18nValues['status']"
                  width="110"
                  align="center"
                  sortable
                ></el-table-column>

                <!-- BatchPrefix -->
                <el-table-column
                  prop="batchPrefix"
                  :label="i18nValues['prefix']"
                  width="92"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Batch -->
                <el-table-column
                  prop="batch"
                  :label="i18nValues['batch']"
                  width="85"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Code -->
                <el-table-column
                  prop="code"
                  :label="i18nValues['code']"
                  width="88"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- ID NUMBER -->
                <el-table-column
                  prop="idNumber"
                  :label="i18nValues['idNumber']"
                  width="78"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Bags Number -->
                <el-table-column
                  prop="bagsNumber"
                  :label="i18nValues['quantity']"
                  width="105"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Net Weight -->
                <el-table-column
                  prop="netWeight"
                  :label="i18nValues['netKg']"
                  width="110"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Gross Weight -->
                <el-table-column
                  prop="grossWeight"
                  :label="i18nValues['grossKG']"
                  width="110"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Seed Per Lb -->
                <el-table-column
                  prop="seedPerLb"
                  :label="i18nValues['seedx1000']"
                  width="88"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- SPP -->
                <el-table-column
                  prop="seedsPerPound"
                  :label="i18nValues['seedsPerPound']"
                  width="76"
                  align="right"
                  sortable
                ></el-table-column>

                <!-- Dispatch Type -->
                <el-table-column
                  prop="dispatchType"
                  :label="i18nValues['shipment']"
                  width="105"
                  align="center"
                  sortable
                ></el-table-column>

                <!-- Pallet Type -->
                <el-table-column
                  prop="palletType"
                  :label="i18nValues['type']"
                  width="82"
                  align="center"
                  sortable
                ></el-table-column>

                <!-- Container/AWB -->
                <el-table-column
                  prop="containerAwb"
                  :label="i18nValues['container']"
                  width="122"
                  align="center"
                  sortable="custom"
                ></el-table-column>

                <!-- Vessel -->
                <el-table-column
                  prop="loadingOrder.vessel"            
                  :label="i18nValues['vessel']"
                  :sort-method="sortMethod"
                  width="83"
                  align="center"
                  sortable="custom"
                ></el-table-column>

                <!-- Dispatch Date -->
                <el-table-column
                  prop="creationDate"
                  :label="i18nValues['registrationDate']"
                  width="160"
                  :formatter="formatCreationDate"
                  align="center"
                  sortable
                ></el-table-column>

                <el-table-column width="145" align="right" fixed="right">
                  <template slot-scope="scope">

                    <el-button
                      v-if="componentsMap.get('pallet_transfer') && (scope.row.status == 'Disponible' || scope.row.status == 'Available')"
                      class="text-info"
                      icon="fas fa-arrow-up"
                      size="small"
                      :title="i18nValues['transfer']"
                      @click="stockTransfer(scope.row)" 
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('pallet_change_available') && scope.row.status == 'On Hold'"
                      class="text-info"
                      icon="fas fa-arrow-left"
                      size="small"
                      :title="i18nValues['available']"
                      @click="changeStatusToAvailable(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('pallet_change_onHold') && (scope.row.status == 'Disponible' || scope.row.status == 'Available')"
                      class="text-info"
                      icon="fas fa-pause"
                      size="small"
                      :title="i18nValues['onHold']"
                      @click="changeStatusToOH(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if=" componentsMap.get('pallet_change_grainPort') && scope.row.status == 'On Hold'"
                      class="text-info"
                      icon="fas fa-anchor"
                      size="small"
                      :title="i18nValues['grainPort']"
                      @click="changeStatusToGp(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if=" componentsMap.get('pallet_change_grainConsumption') && scope.row.status == 'On Hold'"
                      class="text-info"
                      icon="fas fa-arrow-right"
                      size="small"
                      :title="i18nValues['grainConsumption']"
                      @click="changeStatusToGc(scope.row.id)"
                    ></el-button>

                    <el-button
                      v-if="componentsMap.get('pallet_disassemble') && (
                        scope.row.status == 'Disponible' || scope.row.status == 'Available' ||
                          scope.row.status == 'On Hold' || scope.row.status == 'notReady')
                      "
                      class="text-info"
                      icon="fas fa-warehouse"
                      size="small"
                      :title="i18nValues['disassemble'] || 'Disassemble'"
                      @click="showDisassembleDialog(scope.row)"
                    ></el-button>

                    <el-button
                      v-if=" componentsMap.get('pallet_delete') && (
                        scope.row.status == 'Disponible' || scope.row.status == 'Available' ||
                          scope.row.status == 'On Hold')
                      "
                      class="text-danger"
                      icon="fas fa-times"
                      size="small"
                      :title="i18nValues['remove']"
                      @click="erasePallet(scope.row.id)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div v-if="90 > 10" style="height: 15px"></div>
              <div class="pagination-bar">
                <PaginationFunctional
                  ref="pagination"
                  sublistName="PalletsSubList"
                  :fullList.sync="PalletsList"
                  :tableSize="20"
                  :tableIndexInitial="initialPage"
                  @paginationChange="paginationChange"
                  @currentIndexPagination="setCurrentPage"
                  class="text-center"
                />
                <div v-if="PalletsList.length > 0" class="results-info">
                  <p>
                    {{ i18nValues['showing'] || 'Showing' }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues['of'] || 'of' }} {{ totalRecords }} {{ i18nValues['results'] || 'results' }}
                  </p>
                </div>
              </div>
            </div>
          </el-form-item>
        
          <!-- StockTransfer Modal --> 
          <StockTransferModal
              :modalTitle="i18nValues['stockTransferAdmin']"
              :visible.sync="visibleModal"
              ref="stockTransferModal"
              :palletToTransfer="this.palletToTransfer"
              actionIcon="fas fa-edit"
              actionTitle="edit"
              v-on:update:Pallets="updatePallets"
          ></StockTransferModal>

          <!-- Disassemble Pallet Modal -->
          <el-dialog
            :visible.sync="disassembleDialogVisible"
            width="480px"
            :close-on-click-modal="false"
            :show-close="!disassembleLoading"
            custom-class="disassemble-dialog"
          >
            <div slot="title" class="disassemble-dialog-title">
              <i class="fas fa-warehouse disassemble-title-icon"></i>
              {{ (i18nValues['disassemble'] || 'Disassemble') }} Pallet
            </div>

            <div v-loading="disassembleLoading" style="min-height: 80px;">
              <div v-if="disassemblePreviewData">

                <!-- Warning -->
                <div class="disassemble-warning">
                  <i class="fas fa-info-circle"></i>
                  <span>{{ i18nValues['disassembleWarning'] || 'This action cannot be undone. The pallet will be permanently removed, along with its label when one exists.' }}</span>
                </div>

                <el-alert
                  v-if="disassembleCapacityBlocked()"
                  type="error"
                  :closable="false"
                  show-icon
                  class="disassemble-capacity-alert"
                  :title="i18nValues['disassembleCapacityBlockedTitle'] || 'Cannot disassemble: silo capacity exceeded'"
                >
                  <span>{{ i18nValues['disassembleCapacityBlockedBody'] || 'The return amount plus current use would exceed the maximum capacity of at least one destination silo. Free space in those silos or choose another destination before continuing.' }}</span>
                </el-alert>

                <!-- Deletion list (pallet + etiqueta only) -->
                <div class="disassemble-section">
                  <div class="disassemble-row">
                    <div class="disassemble-row-icon"><i class="fas fa-pallet"></i></div>
                    <div class="disassemble-row-label">{{ i18nValues['disassembleRowPallet'] || 'Pallet' }}</div>
                    <div class="disassemble-row-value">
                      <el-tag size="small" type="info" effect="plain">#{{ disassemblePreviewData.palletId }}</el-tag>
                    </div>
                  </div>

                  <div v-if="disassemblePreviewData.labelId" class="disassemble-row">
                    <div class="disassemble-row-icon"><i class="fas fa-tag"></i></div>
                    <div class="disassemble-row-label">{{ i18nValues['label'] || 'Label' }}</div>
                    <div class="disassemble-row-value">
                      <el-tag size="small" type="info" effect="plain">#{{ disassemblePreviewData.labelId }}</el-tag>
                    </div>
                  </div>
                </div>

                <!-- Silo returns -->
                <div v-if="disassemblePreviewData.siloReturns && disassemblePreviewData.siloReturns.length > 0" class="disassemble-silo-section">
                  <div class="disassemble-silo-header">
                    <i class="fas fa-warehouse"></i>
                    {{ i18nValues['stockReturnToSilo'] || 'Stock will return to the silos listed below (plant and silo name):' }}
                  </div>
                  <div
                    v-for="silo in disassemblePreviewData.siloReturns"
                    :key="silo.siloId + '-' + (silo.itemProductId || 0)"
                    class="disassemble-silo-row"
                    :class="{
                      'disassemble-silo-mismatch': !silo.productMatch,
                      'disassemble-silo-capacity-warn': disassembleSiloRowCapacityBlocked(silo)
                    }"
                  >
                    <div v-if="silo.productMatch" style="width: 100%;">
                      <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span class="disassemble-silo-name">
                          <template v-if="silo.fieldSiteName">
                            <span class="disassemble-silo-plant">{{ i18nValues['fieldSite'] || 'Plant' }}: {{ silo.fieldSiteName }}</span>
                            <span class="disassemble-silo-sep"> — </span>
                          </template>
                          {{ silo.siloName }}
                        </span>
                        <span class="disassemble-silo-kg">
                          <i class="fas fa-arrow-right disassemble-silo-arrow"></i>
                          <strong>{{ silo.kgToReturn.toFixed(2) }}</strong> kg
                        </span>
                      </div>
                      <div
                        v-if="disassembleSiloRowCapacityBlocked(silo)"
                        class="disassemble-silo-capacity-inline"
                      >
                        <i class="fas fa-ban"></i>
                        {{ i18nValues['disassembleSiloCapacityInline'] || 'This destination would exceed silo max capacity.' }}
                      </div>
                      <!-- Field selector: shown when the silo has no field assigned -->
                      <div v-if="!silo.fieldId" style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #f2f3f5;">
                        <div style="font-size: 12px; color: #e6a23c; margin-bottom: 4px;">
                          <i class="fas fa-exclamation-triangle"></i>
                          {{ i18nValues['siloNoField'] || 'This silo has no field assigned. Please select one:' }}
                        </div>
                        <el-select
                          v-model="fieldOverrides[silo.siloId]"
                          :placeholder="i18nValues['selectField'] || 'Select a field'"
                          size="mini"
                          style="width: 100%;"
                          filterable
                        >
                          <el-option
                            v-for="field in FieldList"
                            :key="field.id"
                            :value="field.id"
                            :label="field.name"
                          />
                        </el-select>
                      </div>
                    </div>
                    <div v-if="!silo.productMatch" style="width: 100%;">
                      <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
                        <i class="fas fa-exclamation-circle" style="color: #f56c6c;"></i>
                        <span style="font-size: 12px; color: #f56c6c; font-weight: 500;">
                          {{ i18nValues['productMismatch'] || 'Product mismatch' }}
                        </span>
                        <span style="font-size: 12px; color: #909399;">
                          — <template v-if="silo.fieldSiteName">{{ silo.fieldSiteName }} — </template>{{ silo.siloName }}
                        </span>
                        <span class="disassemble-silo-kg" style="margin-left: auto;">
                          <strong>{{ silo.kgToReturn.toFixed(2) }}</strong> kg
                        </span>
                      </div>
                      <div style="font-size: 11px; color: #909399; margin-bottom: 8px;">
                        {{ i18nValues['product'] || 'Product' }}: <strong>{{ silo.itemProductBrand }} - {{ silo.itemProductName }}</strong>
                        &nbsp;|&nbsp;
                        {{ i18nValues['silo'] || 'Silo' }}: <strong>{{ silo.siloProductBrand || '—' }} - {{ silo.siloProductName || 'N/A' }}</strong>
                      </div>
                      <el-select
                        v-model="siloOverrides[silo.siloId]"
                        :placeholder="i18nValues['selectSilo'] || 'Select destination silo'"
                        size="mini"
                        style="width: 100%;"
                        filterable
                      >
                        <el-option
                          v-for="alt in getFilteredSilos(silo.itemProductId)"
                          :key="alt.siloId"
                          :value="alt.siloId"
                          :label="disassembleAltSiloOptionLabel(alt)"
                        >
                          <span style="float: left;">
                            <template v-if="alt.fieldSiteName">{{ alt.fieldSiteName }} — </template>{{ alt.siloName }}
                          </span>
                          <span style="float: right; color: #909399; font-size: 12px;">
                            {{ alt.productName ? alt.productBrand + ' - ' + alt.productName : '(empty)' }}
                            — {{ alt.percentageUsed != null ? alt.percentageUsed + '%' : '0%' }}
                          </span>
                        </el-option>
                      </el-select>
                      <div
                        v-if="disassembleSiloRowCapacityBlocked(silo)"
                        class="disassemble-silo-capacity-inline"
                        style="margin-top: 8px;"
                      >
                        <i class="fas fa-ban"></i>
                        {{ i18nValues['disassembleSiloCapacityInline'] || 'This destination would exceed silo max capacity.' }}
                      </div>
                      <!-- Field selector: shown when the selected override silo has no field -->
                      <div v-if="overrideSiloHasNoField(silo.siloId)" style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #f2f3f5;">
                        <div style="font-size: 12px; color: #e6a23c; margin-bottom: 4px;">
                          <i class="fas fa-exclamation-triangle"></i>
                          {{ i18nValues['siloNoField'] || 'This silo has no field assigned. Please select one:' }}
                        </div>
                        <el-select
                          v-model="fieldOverrides[effectiveSiloId(silo.siloId)]"
                          :placeholder="i18nValues['selectField'] || 'Select a field'"
                          size="mini"
                          style="width: 100%;"
                          filterable
                        >
                          <el-option
                            v-for="field in FieldList"
                            :key="field.id"
                            :value="field.id"
                            :label="field.name"
                          />
                        </el-select>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="disassembleDialogVisible = false" size="small" :disabled="disassembleLoading">
                {{ i18nValues['cancel'] || 'Cancel' }}
              </el-button>
              <el-button
                type="danger"
                @click="confirmDisassemble()"
                size="small"
                :loading="disassembleLoading"
                :disabled="!disassemblePreviewData || hasPendingOverrides() || hasPendingFieldSelections() || disassembleCapacityBlocked()"
                icon="fas fa-warehouse"
              >
                {{ i18nValues['disassemble'] || 'Disassemble' }}
              </el-button>
            </span>
          </el-dialog>

        </el-form>


      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
import StockTransferModal from "../../components/customer/invoicingmodule/modals/StockTransferModal.vue"; // eslint-disable-line no-unused-vars

export default {
  name: "PalletAdmin",
  created() {
    this.restoreFromQuery();
    this.retrieveProducts();
  },

  components: {
    PaginationFunctional,
    StockTransferModal
  },

  computed: {
    loading: get("pallet/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
    selectedLanguage: get("i18nStore/selectedLanguage"),

    optionsStatus() {
      return [
        { value: "available", label: this.i18nValues["available"] },
        { value: "loaded", label: this.i18nValues["loaded"] },
        { value: "forLoading", label: this.i18nValues["forLoading"] },
        { value: "dispatched", label: this.i18nValues["sent"] },
        { value: "onHold", label: this.i18nValues["onHold"] },
        { value: "discarded", label: this.i18nValues["discarded"] },
        { value: "grainPort", label: this.i18nValues["grainPort"] },
        { value: "grainConsumption", label: this.i18nValues["grainConsumption"] },
      ];
    },

    optionsDispatch() {
      return [
        { value: "plane", label: this.i18nValues["aerial"] },
        { value: "ship", label: this.i18nValues["maritime"] },
      ];
    },

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      return Array.isArray(this.PalletsList) ? this.PalletsList.length : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },

    // variedades() {
    //   return [
    //     { value: "corn", label: this.i18nValues["cornSeed"] },
    //     { value: "soy", label: this.i18nValues["soybeanProduction"] },
    //     { value: "soyRD", label: this.i18nValues["soybeanRD"] },
    //   ];
    // },
  },

  props:{
    componentsMap: {},
  },

  watch: {
    globalFieldSite: {
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        // Skip partial→full object update from TopBar
        if (oldVal && oldVal.id && oldVal.id === newVal.id) return;
        // Invalidate in-flight requests
        this.requestGeneration++;
        this.PalletsList = [];
        this.PalletsSubList = [];
        this.originalPalletsList = [];
        // Reset filters when fieldSite changes (not on first load)
        if (oldVal && oldVal.id) {
          this.filter = {
            status: null, dispatchType: null, id: null,
            name: null, batch: null, creationDate: null, cropType: null,
          };
          this.initialPage = 1;
          this.sortProp = null;
          this.sortOrder = null;
        }
        this.fetchPallets(true);
        this.retrievePalletCount();
        this.syncRouteFromState();
      },
      immediate: true,
    },
    globalCampaign: {
      handler(newVal, oldVal) {
        if (!newVal || !newVal.id) return;
        if (oldVal && oldVal.id && oldVal.id === newVal.id) return;
        // Invalidate in-flight requests
        this.requestGeneration++;
        this.PalletsList = [];
        this.PalletsSubList = [];
        this.originalPalletsList = [];
        // Reset filters when campaign changes (not on first load)
        if (oldVal && oldVal.id) {
          this.filter = {
            status: null, dispatchType: null, id: null,
            name: null, batch: null, creationDate: null, cropType: null,
          };
          this.initialPage = 1;
          this.sortProp = null;
          this.sortOrder = null;
        }
        if (this.globalFieldSite && this.globalFieldSite.id) {
          this.fetchPallets(true);
          this.retrievePalletCount();
        }
        this.retrieveProducts();
        this.syncRouteFromState();
      },
      immediate: true,
    },
    i18nValues: {
      handler() {
        // Re-translate if language changes
      },
      deep: true,
    },
    siloOverrides: {
      handler(newVal, oldVal) {
        // Clear field overrides for previous override silo when selection changes
        if (oldVal) {
          var oldKeys = Object.keys(oldVal);
          for (var i = 0; i < oldKeys.length; i++) {
            var oldTarget = oldVal[oldKeys[i]];
            var newTarget = newVal ? newVal[oldKeys[i]] : null;
            if (oldTarget && oldTarget !== newTarget) {
              this.$delete(this.fieldOverrides, oldTarget);
            }
          }
        }
      },
      deep: true,
    },
  },

  data() {
    const q = (this.$route && this.$route.query) || {};
    const parseQueryDate = (value) => {
      if (value === undefined || value === null || value === "") {
        return null;
      }
      const numeric = Number(value);
      if (!isNaN(numeric)) {
        const dt = new Date(numeric);
        return isNaN(dt.getTime()) ? null : dt;
      }
      const dt = new Date(value);
      return isNaN(dt.getTime()) ? null : dt;
    };
    return {
      PalletsListT: [], //SE BORRA

      filter: {
        status: q.status || null,
        dispatchType: q.dispatchType || null,
        id: q.id || null,
        name: q.name || null,
        batch: q.batch || null,
        creationDate: q.creationDate ? parseQueryDate(q.creationDate) : null,
        cropType: q.cropType || null,
      },

      //code: null,

      ProductList: [],

      variedades: [
        { value: "corn", label: "Corn Seed" },
        { value: "soy", label: "Soybean Production" },
        { value: "soyRD", label: "Soybean R&D" },
      ],

      PalletsList: [],
      PalletsSubList: [],
      originalPalletsList: [],
      cantidad: 100,

      // Query/pagination state sync
      initialPage: q.page ? Number(q.page) : 1,
      sortProp: q.sortProp || null,
      sortOrder: q.sortOrder || null,
      requestGeneration: 0,
      hasAttemptedLoad: false,

      palletToTransferId: 0,
      palletToTransfer: {
        loadingOrder: {},
        label: {}
      },
      visibleModal: false,

      disassembleDialogVisible: false,
      disassemblePreviewData: null,
      disassembleLoading: false,
      disassemblePalletId: null,
      siloOverrides: {},
      fieldOverrides: {},
      FieldList: [],
    };
  },

  methods: {

    // ── Central fetch — called by watchers, search button, and actions ──
    fetchPallets(preservePage) {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      this.hasAttemptedLoad = true;
      var gen = ++this.requestGeneration;

      var fieldSiteId = this.globalFieldSite.id;
      var campaignId = this.globalCampaign ? this.globalCampaign.id : null;

      // Normalize filter values
      var f = this.filter || {};
      if (f.id === "") f.id = null;
      if (f.name === "") f.name = null;
      if (f.batch === "") f.batch = null;
      if (f.cropType === "") f.cropType = null;

      var hasFilters = !!(f.status || f.dispatchType || f.id || f.name ||
        f.batch || f.creationDate || f.cropType);

      // Build payload with fieldSiteId and campaignId
      var payload = Object.assign({}, f, {
        fieldSiteId: fieldSiteId,
        campaignId: campaignId,
      });
      // Serialize date for API
      if (payload.creationDate instanceof Date) {
        payload.creationDate = payload.creationDate.getTime();
      }

      var promise = hasFilters
        ? this.$store.dispatch("pallet/retrievePalletsBySearch", payload)
        : this.$store.dispatch("pallet/retrievePallets", payload);

      promise.then((res) => {
        // ── Stale-response guard ──
        if (gen !== this.requestGeneration) return;

        var preparedList = this.preparePalletList(res);
        this.originalPalletsList = preparedList;

        // Apply sorting
        var nextList;
        if (!this.sortProp || !this.sortOrder) {
          nextList = [].concat(preparedList);
        } else {
          var helperSorted = this.sortUsingHelper(preparedList, this.sortProp, this.sortOrder);
          nextList = Array.isArray(helperSorted) ? helperSorted : this.sortListLocally(preparedList, this.sortProp, this.sortOrder);
        }
        this.PalletsList = nextList;

        if (!preservePage) {
          this.initialPage = 1;
        }

        this.syncRouteFromState();

        // Sync pagination
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            var targetPage = preservePage ? (this.initialPage || 1) : 1;
            this.$refs.pagination.currentChange(targetPage);
          }
        });
      });
    },

    // Aliases — existing callers keep working
    retrievePalletsBySearch() {
      this.fetchPallets(false);
    },
    retrievePallets() {
      this.fetchPallets(true);
    },

    sortMethod() {
      return 0;
    },

    handleSortChange(event) {
      var nextProp = event && event.prop ? event.prop : null;
      var nextOrder = event && event.order ? event.order : null;
      var sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (!sortChanged) return;

      // Re-sort from original list
      var baseList = Array.isArray(this.originalPalletsList) ? this.originalPalletsList : [];
      var nextList;
      if (!this.sortProp || !this.sortOrder) {
        nextList = [].concat(baseList);
      } else {
        var helperSorted = this.sortUsingHelper(baseList, this.sortProp, this.sortOrder);
        nextList = Array.isArray(helperSorted) ? helperSorted : this.sortListLocally(baseList, this.sortProp, this.sortOrder);
      }
      this.PalletsList = nextList;

      var currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex : this.initialPage || 1;
      this.initialPage = currentPage;
      this.syncRouteFromState();
      this.$nextTick(() => {
        if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
          this.$refs.pagination.currentChange(currentPage);
        }
      });
    },

    generate() {
      this.$store.dispatch("pallet/generate").then((res) => {
        this.PalletsListT = res;
      });
    },

    formatCreationDate(row) {
      return this.formatDate(row.creationDate);
    },

    translate(item) {
      if (item.dispatchType == "plane") {
        item.dispatchType = this.i18nValues["aerial"];
      }
      if (item.dispatchType == "ship") {
        item.dispatchType = this.i18nValues["maritime"];
      }
      if (item.status == "available") {
        item.status = this.i18nValues["available"];
      }
      if (item.status == "forLoading") {
        item.status = this.i18nValues["forLoading"];
      }
      if (item.status == "loaded") {
        item.status = this.i18nValues["loaded"];
      }
      if (item.status == "dispatched") {
        item.status = this.i18nValues["sent"];
      }
      if (item.status == "onHold") {
        item.status = this.i18nValues["onHold"];
      }
      if (item.status == "discarded") {
        item.status = this.i18nValues["discarded"];
      }
      if (item.status == "grainPort") {
        item.status = this.i18nValues["grainPort"];
      }
      if (item.status == "grainConsumption") {
        item.status = this.i18nValues["grainConsumption"];
      }
      if (item.status == "erased") {
        item.status = this.i18nValues["erased"];
      }
    },

    roundGrossAndNetWeight(item) {
      item.grossWeight = Math.round(item.grossWeight * 100) / 100;
      item.netWeight = Math.round(item.netWeight * 100) / 100;
    },

    preparePalletList(rawList) {
      if (!Array.isArray(rawList)) {
        return [];
      }
      const seenIds = new Set();
      const prepared = [];
      rawList.forEach((item) => {
        if (!item) {
          return;
        }
        this.decoratePallet(item);
        if (item.id != null) {
          if (seenIds.has(item.id)) {
            return;
          }
          seenIds.add(item.id);
        }
        prepared.push(item);
      });
      return prepared;
    },

    decoratePallet(item) {
      item.code = item.id;
      this.setOrderIdCreated(item);
      this.setBrandCreated(item);
      this.setContainerAWBCreated(item);
      this.setLabelIdCreated(item);
      this.setVesselCreated(item);
      this.translate(item);
      this.roundGrossAndNetWeight(item);
    },

    erasePallet(id) {
      this.$confirm(
        "Está seguro que quiere eliminar el pallet?",
        "Eliminar Pallet",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("pallet/erasePallet", id).then((res) => {
          if (res.status == "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["palletDeleted"],
              position: "bottom-right",
            });
            this.fetchPallets(true);
            this.retrievePalletCount();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: this.i18nValues["palletDeleteError"],
              position: "bottom-right",
            });
          }
        });
      });
    },

    showDisassembleDialog(row) {
      this.disassemblePalletId = row.code || row.id;
      this.disassemblePreviewData = null;
      this.siloOverrides = {};
      this.fieldOverrides = {};
      this.disassembleDialogVisible = true;
      this.disassembleLoading = true;
      this.loadFieldsForDialog();

      this.$store.dispatch("pallet/disassemblePreview", this.disassemblePalletId).then((res) => {
        if (res.status === "OK") {
          this.disassemblePreviewData = res;
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: res.statusDescription || this.i18nValues["error"],
            position: "bottom-right",
          });
          this.disassembleDialogVisible = false;
        }
      }).catch(() => {
        this.$notify.error({
          title: this.i18nValues["error"],
          message: this.i18nValues["error"],
          position: "bottom-right",
        });
        this.disassembleDialogVisible = false;
      }).finally(() => {
        this.disassembleLoading = false;
      });
    },

    getKgByEffectiveTargetMap() {
      var out = {};
      if (!this.disassemblePreviewData || !this.disassemblePreviewData.siloReturns) {
        return out;
      }
      var returns = this.disassemblePreviewData.siloReturns;
      for (var i = 0; i < returns.length; i++) {
        var r = returns[i];
        var ov = this.siloOverrides[r.siloId];
        var target = ov !== undefined && ov !== null && ov !== "" ? ov : r.siloId;
        var add = r.kgToReturn != null ? Number(r.kgToReturn) : 0;
        out[target] = (out[target] || 0) + add;
      }
      return out;
    },

    getCapacityForSiloId(siloId) {
      var id = Number(siloId);
      var avList = (this.disassemblePreviewData && this.disassemblePreviewData.availableSilos) || [];
      for (var a = 0; a < avList.length; a++) {
        if (Number(avList[a].siloId) === id) {
          return {
            used: avList[a].usedKg != null ? Number(avList[a].usedKg) : 0,
            max: avList[a].maxKg != null ? Number(avList[a].maxKg) : null
          };
        }
      }
      var retList = (this.disassemblePreviewData && this.disassemblePreviewData.siloReturns) || [];
      for (var b = 0; b < retList.length; b++) {
        if (Number(retList[b].siloId) === id) {
          return {
            used: retList[b].siloUsedKg != null ? Number(retList[b].siloUsedKg) : 0,
            max: retList[b].siloMaxKg != null ? Number(retList[b].siloMaxKg) : null
          };
        }
      }
      return { used: 0, max: null };
    },

    disassembleCapacityBlocked() {
      var map = this.getKgByEffectiveTargetMap();
      var keys = Object.keys(map);
      for (var j = 0; j < keys.length; j++) {
        var tid = keys[j];
        var cap = this.getCapacityForSiloId(tid);
        var max = cap.max;
        if (max != null && max > 0 && cap.used + map[tid] > max + 0.01) {
          return true;
        }
      }
      return false;
    },

    disassembleSiloRowCapacityBlocked(silo) {
      var ov = this.siloOverrides[silo.siloId];
      var target = ov !== undefined && ov !== null && ov !== "" ? ov : silo.siloId;
      var map = this.getKgByEffectiveTargetMap();
      var cap = this.getCapacityForSiloId(target);
      var max = cap.max;
      if (max == null || max <= 0) {
        return false;
      }
      var total = map[target] != null ? map[target] : 0;
      return cap.used + total > max + 0.01;
    },

    getFilteredSilos(itemProductId) {
      if (!this.disassemblePreviewData || !this.disassemblePreviewData.availableSilos) return [];
      return this.disassemblePreviewData.availableSilos.filter(function(s) {
        return (s.productId === itemProductId) || !s.productId || !s.usedKg || s.usedKg === 0;
      });
    },

    findAvailableSiloById(siloId) {
      if (!this.disassemblePreviewData || !this.disassemblePreviewData.availableSilos) return null;
      var id = Number(siloId);
      for (var i = 0; i < this.disassemblePreviewData.availableSilos.length; i++) {
        if (Number(this.disassemblePreviewData.availableSilos[i].siloId) === id) {
          return this.disassemblePreviewData.availableSilos[i];
        }
      }
      return null;
    },

    effectiveSiloId(originalSiloId) {
      var ov = this.siloOverrides[originalSiloId];
      return (ov !== undefined && ov !== null && ov !== "") ? ov : originalSiloId;
    },

    overrideSiloHasNoField(originalSiloId) {
      var ov = this.siloOverrides[originalSiloId];
      if (!ov) return false;
      var target = this.findAvailableSiloById(ov);
      return target && !target.fieldId;
    },

    disassembleAltSiloOptionLabel(alt) {
      if (!alt) return "";
      var plant = alt.fieldSiteName ? alt.fieldSiteName + " — " : "";
      var prod = alt.productName ? " (" + alt.productBrand + " - " + alt.productName + ")" : " (empty)";
      return plant + alt.siloName + prod;
    },

    hasPendingOverrides() {
      if (!this.disassemblePreviewData || !this.disassemblePreviewData.hasProductMismatch) return false;
      var mismatched = this.disassemblePreviewData.siloReturns.filter(function(s) { return !s.productMatch; });
      for (var i = 0; i < mismatched.length; i++) {
        if (!this.siloOverrides[mismatched[i].siloId]) return true;
      }
      return false;
    },

    hasPendingFieldSelections() {
      if (!this.disassemblePreviewData || !this.disassemblePreviewData.siloReturns) return false;
      // Check original silos with no field (productMatch case)
      var siloReturns = this.disassemblePreviewData.siloReturns;
      for (var i = 0; i < siloReturns.length; i++) {
        var s = siloReturns[i];
        if (s.productMatch && !s.fieldId) {
          if (!this.fieldOverrides[s.siloId]) return true;
        }
        // Check override silos with no field (mismatch case)
        if (!s.productMatch && this.siloOverrides[s.siloId]) {
          var targetId = this.siloOverrides[s.siloId];
          var targetSilo = this.findAvailableSiloById(targetId);
          if (targetSilo && !targetSilo.fieldId) {
            if (!this.fieldOverrides[targetId]) return true;
          }
        }
      }
      return false;
    },

    loadFieldsForDialog() {
      this.$store.dispatch("field/retrieveFields").then((res) => {
        this.FieldList = Array.isArray(res) ? res : [];
      });
    },

    confirmDisassemble() {
      if (this.hasPendingOverrides()) {
        this.$notify.warning({
          title: this.i18nValues["warning"] || "Warning",
          message: this.i18nValues["selectSiloRequired"] || "Please select a destination silo for all mismatched entries",
          position: "bottom-right",
        });
        return;
      }
      if (this.hasPendingFieldSelections()) {
        this.$notify.warning({
          title: this.i18nValues["warning"] || "Warning",
          message: this.i18nValues["selectFieldRequired"] || "Please select a field for all silos with no assigned field.",
          position: "bottom-right",
        });
        return;
      }
      if (this.disassembleCapacityBlocked()) {
        this.$notify.error({
          title: this.i18nValues["error"] || "Error",
          message: this.i18nValues["disassembleCapacityBlockedBody"] || "Silo capacity would be exceeded.",
          position: "bottom-right",
        });
        return;
      }

      this.disassembleLoading = true;
      var overridesList = [];
      var keys = Object.keys(this.siloOverrides);
      for (var i = 0; i < keys.length; i++) {
        overridesList.push({
          originalSiloId: Number(keys[i]),
          targetSiloId: this.siloOverrides[keys[i]]
        });
      }

      var fieldAssignmentsList = [];
      var fieldKeys = Object.keys(this.fieldOverrides);
      for (var j = 0; j < fieldKeys.length; j++) {
        if (this.fieldOverrides[fieldKeys[j]]) {
          fieldAssignmentsList.push({
            siloId: Number(fieldKeys[j]),
            fieldId: this.fieldOverrides[fieldKeys[j]]
          });
        }
      }

      this.$store.dispatch("pallet/disassemblePallet", {
        id: this.disassemblePalletId,
        siloOverrides: overridesList.length > 0 ? overridesList : null,
        fieldAssignments: fieldAssignmentsList.length > 0 ? fieldAssignmentsList : null
      }).then((res) => {
        if (res.status === "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["disassembleSuccess"] || "Pallet disassembled successfully",
            position: "bottom-right",
          });
          this.disassembleDialogVisible = false;
          this.fetchPallets(true);
          this.retrievePalletCount();
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: res.statusDescription || this.i18nValues["disassembleError"] || "Error disassembling pallet",
            position: "bottom-right",
          });
        }
      }).catch(() => {
        this.$notify.error({
          title: this.i18nValues["error"],
          message: this.i18nValues["disassembleError"] || "Error disassembling pallet",
          position: "bottom-right",
        });
      }).finally(() => {
        this.disassembleLoading = false;
      });
    },

    exportExcel() {
      console.log("Selected Language:", this.selectedLanguage); // eslint-disable-line

      this.filter.campaignId = this.globalCampaign
        ? this.globalCampaign.id
        : null;
      this.filter.fieldSiteId = this.globalFieldSite.id;
      this.filter.selectedLanguage = this.selectedLanguage
      this.$store
        .dispatch("pallet/exportExcelPallet", this.filter)
        .then((res) => {
          var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          const links = document.createElement("a");
          links.href = URL.createObjectURL(blob);
          links.download = "Pallet_Exportaciones.xlsx";
          links.click();
          URL.revokeObjectURL(links.href);
        });
    },

    changeStatusToAvailable(id) {
      var pallet = {
        id: id,
        status: "available",
      };
      this.$store.dispatch("pallet/savePallet", pallet).then((res) => {
        if (res.status == "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["palletOnHold"],
            position: "bottom-right",
          });
          this.fetchPallets(true);
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["palletOnHoldError"],
            position: "bottom-right",
          });
        }
      });
    },

    changeStatusToOH(id) {
      var pallet = {
        id: id,
        status: "onHold",
      };
      this.$store.dispatch("pallet/savePallet", pallet).then((res) => {
        if (res.status == "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["palletOnHold"],
            position: "bottom-right",
          });
          this.fetchPallets(true);
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["palletOnHoldError"],
            position: "bottom-right",
          });
        }
      });
    },

    changeStatusToGp(id) {
      var pallet = {
        id: id,
        status: "grainPort",
      };
      this.$store.dispatch("pallet/savePallet", pallet).then((res) => {
        if (res.status == "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["palletGrainPort"],
            position: "bottom-right",
          });
          this.fetchPallets(true);
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["palletGrainPortError"],
            position: "bottom-right",
          });
        }
      });
    },

    changeStatusToGc(id) {
      var pallet = {
        id: id,
        status: "grainConsumption",
      };
      this.$store.dispatch("pallet/savePallet", pallet).then((res) => {
        if (res.status == "OK") {
          this.$notify.success({
            title: this.i18nValues["success"],
            message: this.i18nValues["palletGrainConsumption"],
            position: "bottom-right",
          });
          this.fetchPallets(true);
        } else {
          this.$notify.error({
            title: this.i18nValues["error"],
            message: this.i18nValues["palletGrainConsumptionError"],
            position: "bottom-right",
          });
        }
      });
    },

    retrieveProducts() {
      const productFilter = {};
      productFilter.campaignId = this.globalCampaign
        ? this.globalCampaign.id
        : null;
      this.$store
        .dispatch("product/retrieveProducts", productFilter)
        .then((res) => {
          this.ProductList = res;
        });
    },

    retrievePalletCount() {
      if (!this.globalFieldSite || !this.globalFieldSite.id) return;
      var gen = this.requestGeneration;
      const filter = {
        fieldSiteId: this.globalFieldSite.id,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null
      };
      this.$store
        .dispatch("pallet/countPallets", filter)
        .then((res) => {
          if (gen !== this.requestGeneration) return;
          this.cantidad = res;
        });
    },

    setOrderIdCreated(item) {
      if (item.loadingOrder) {
        if (!item.loadingOrder.id) {
          item.loadingOrder.id = null;
        }
        if (item.status == "available" || item.status == "Disponible" || item.status == "Para Cargar" || item.status == "forLoading") {
          item.loadingOrder.id = null;
        }
      }
    },

    setBrandCreated(item) {
      if (item.product) {
        if (!item.product.brand) {
          item.product.brand = null;
        }
      }
    },

    setContainerAWBCreated(item) {
      if (item.loadingOrder != null && item.loadingOrder != undefined) {
        if ( item.status != "available" && item.status != "Disponible" && item.status != "Para Cargar" && item.status != "forLoading") {
          if (item.loadingOrder.container != null && item.loadingOrder.container != "") {
            item.containerAwb = item.loadingOrder.container.toString();
          } else if (item.loadingOrder.airGuide != null && item.loadingOrder.airGuide != "") {
            item.containerAwb = item.loadingOrder.airGuide.toString();
          } else {
            item.containerAwb = null;
          }
        } else {
          item.containerAwb = null;
        }
      } else {
          item.containerAwb = null;
      }
    },

    setLabelIdCreated(item) {
      if (item.label) {
        if (!item.label.id) {
          item.label.id = null;
        }
      }
    },

    setVesselCreated(item) {
      if (item.loadingOrder) {
        if (!item.loadingOrder.vessel) {
            item.loadingOrder.vessel = null;
          }
        if (item.status == "available" || item.status == "Disponible" || item.status == "Para Cargar" || item.status == "forLoading") {
            item.loadingOrder.vessel = null;    
        } 
      }
    },

    toggleFilters() {
      // removed: filters are always visible
    },

    stockTransfer(id) {
      //this.palletToTransferId = id;
      this.palletToTransfer = id;
      this.visibleModal = true;
      console.log("Pallet: ", id);//eslint-disable-line
    },

    updatePallets() {
      this.fetchPallets(true);
    },

    sortUsingHelper(list, prop, order) {
      // For 'batch', always fall back to local sort to preserve string semantics
      if (prop === "batch") {
        return null;
      }
      if (
        this.$refs &&
        this.$refs.pagination &&
        typeof this.$refs.pagination.handleSortChangePagination === "function"
      ) {
        return this.$refs.pagination.handleSortChangePagination(
          { prop, order },
          list
        );
      }
      return null;
    },

    sortListLocally(list, prop, order) {
      if (!Array.isArray(list) || !prop || !order) {
        return Array.isArray(list) ? [...list] : [];
      }
      const direction = order === "descending" ? -1 : 1;
      return [...list].sort((a, b) => {
        const aVal = this.getValueByPath(a, prop);
        const bVal = this.getValueByPath(b, prop);
        const aEmpty = this.isEmptyValue(aVal);
        const bEmpty = this.isEmptyValue(bVal);
        
        // Empty/null values always go to the end, regardless of sort direction
        if (aEmpty && bEmpty) {
          return 0;
        }
        if (aEmpty) {
          // Use a large positive value to ensure empty always goes to end
          return Number.MAX_SAFE_INTEGER;
        }
        if (bEmpty) {
          // Use a large negative value to ensure empty always goes to end
          return -Number.MAX_SAFE_INTEGER;
        }
        // Certain props (like 'batch') should always be treated as strings,
        // even if they look numeric (e.g. to preserve leading zeros).
        const forceStringProps = ["batch"];
        const treatAsString = forceStringProps.includes(prop);

        if (!treatAsString && this.isNumeric(aVal) && this.isNumeric(bVal)) {
          return (Number(aVal) - Number(bVal)) * direction;
        }
        const comparison = String(aVal).localeCompare(String(bVal), undefined, {
          sensitivity: "base",
        });
        return comparison * direction;
      });
    },

    getValueByPath(item, path) {
      if (!item || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, item);
    },

    isEmptyValue(value) {
      if (value === null || value === undefined) {
        return true;
      }
      if (typeof value === "string") {
        return value.trim() === "";
      }
      return value === "";
    },

    isNumeric(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },

    // --- Pagination & query sync ---
    paginationChange(evt) {
      if (evt && evt.list) {
        this.PalletsSubList = evt.list;
      }
      var currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex
        ? this.$refs.pagination.tableIndex : this.initialPage;
      this.initialPage = currentIdx || 1;
      this.syncRouteFromState();
    },

    setCurrentPage(idx) {
      if (typeof idx === "number") {
        this.initialPage = idx;
        this.syncRouteFromState();
      }
    },

    restoreFromQuery() {
      var q = this.$route.query || {};
      this.filter = this.filter || {};
      this.filter.status = q.status || null;
      this.filter.dispatchType = q.dispatchType || null;
      this.filter.id = q.id || null;
      this.filter.name = q.name || null;
      this.filter.batch = q.batch || null;
      this.filter.creationDate = q.creationDate ? this.parseDate(q.creationDate) : null;
      this.filter.cropType = q.cropType || null;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    syncRouteFromState() {
      var q = {};
      if (this.filter) {
        if (this.filter.status) q.status = this.filter.status;
        if (this.filter.dispatchType) q.dispatchType = this.filter.dispatchType;
        if (this.filter.id) q.id = String(this.filter.id);
        if (this.filter.name) q.name = this.filter.name;
        if (this.filter.batch) q.batch = String(this.filter.batch);
        if (this.filter.creationDate) q.creationDate = this.serializeDate(this.filter.creationDate);
        if (this.filter.cropType) q.cropType = this.filter.cropType;
      }
      q.page = String(this.initialPage || 1);
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
      if (this.globalCampaign && this.globalCampaign.id) q.campaignId = String(this.globalCampaign.id);

      var currentQ = this.$route.query || {};
      var keys = Object.keys(q);
      var isSame = keys.length === Object.keys(currentQ).length &&
        keys.every(function(k) { return String(q[k]) === String(currentQ[k]); });
      if (isSame) return;
      this.$router.replace({ query: q }).catch(function() {});
    },

    serializeDate(d) {
      try {
        const dt = new Date(d);
        if (!isNaN(dt.getTime())) {
          const y = dt.getFullYear();
          const m = `${dt.getMonth() + 1}`.padStart(2, '0');
          const day = `${dt.getDate()}`.padStart(2, '0');
          return `${y}-${m}-${day}`;
        }
        // if it's a number/string timestamp, pass through
        if (typeof d === 'number') return d;
        const asNum = Number(d);
        return isNaN(asNum) ? undefined : asNum;
      } catch(e) { return undefined; }
    },

    parseDate(s) {
      const asNum = Number(s);
      if (!isNaN(asNum)) {
        const dt = new Date(asNum);
        return isNaN(dt.getTime()) ? null : dt;
      }
      const dt = new Date(s);
      return isNaN(dt.getTime()) ? null : dt;
    },
  },
};
</script>

<style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 1;
  min-width: 140px;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
  min-width: 120px;
  max-width: 100%;
}

/* Date picker slightly wider */
.filters-row /deep/ .el-date-editor {
  width: 150px;
  min-width: 130px;
  max-width: 100%;
}

/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
  white-space: nowrap;
}

/* Fixed column styling to work with tree-props */
#PalletsTable /deep/ .el-table__fixed-right {
  z-index: 3;
}

#PalletsTable /deep/ .el-table__fixed-right .el-table__fixed-body-wrapper {
  background-color: #fff;
}

/* Tree table row styling for better visual separation */
#PalletsTable /deep/ .el-table__row {
  border-bottom: 1px solid #e8eaec;
}

/* Child rows - Element UI tree tables indent child rows with padding-left on first cell */
#PalletsTable /deep/ .el-table__body .el-table__row td:first-child[style*="padding-left"] {
  position: relative;
  border-left: 4px solid #409eff;
  background-color: #f8f9fa;
}

/* Apply background to entire row when first cell is indented */
#PalletsTable /deep/ .el-table__body .el-table__row:has(td:first-child[style*="padding-left"]) {
  background-color: #f8f9fa;
}

/* Fallback for browsers without :has() support - style the row cells */
#PalletsTable /deep/ .el-table__body .el-table__row td:first-child[style*="padding-left"] ~ td {
  background-color: #f8f9fa;
}

/* Stronger border for parent rows to separate groups */
#PalletsTable /deep/ .el-table__body .el-table__row:not(:has(td:first-child[style*="padding-left"])) {
  border-bottom: 2px solid #d0d7de;
}

/* Hover effects */
#PalletsTable /deep/ .el-table__row:hover {
  background-color: #f0f2f5 !important;
}

/* Child rows hover - different color */
#PalletsTable /deep/ .el-table__row:has(td:first-child[style*="padding-left"]):hover {
  background-color: #e8ecf0 !important;
}

/* Fallback hover for child rows */
#PalletsTable /deep/ .el-table__row td:first-child[style*="padding-left"]:hover ~ td,
#PalletsTable /deep/ .el-table__row:hover td:first-child[style*="padding-left"] ~ td {
  background-color: #e8ecf0 !important;
}

/* Table container with minimum height to prevent loading overlay jumping */
.table-container {
  min-height: 400px;
  position: relative;
}

/* Pagination + results inline, right-aligned */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266; /* match label color */
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266; /* match label color */
  font-weight: 500;
}

/* Disassemble modal */
.disassemble-dialog-title {
  font-size: 17px;
  font-weight: 600;
  color: #303133;
  display: flex;
  align-items: center;
}

.disassemble-title-icon {
  margin-right: 8px;
  color: #909399;
  font-size: 16px;
}

.disassemble-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: #f4f4f5;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  margin-bottom: 18px;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}

.disassemble-warning i {
  margin-top: 2px;
  flex-shrink: 0;
  color: #909399;
}

.disassemble-section {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.disassemble-row {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #f2f3f5;
}

.disassemble-row:last-child {
  border-bottom: none;
}

.disassemble-row:hover {
  background: #fafafa;
}

.disassemble-row-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #f4f4f5;
  color: #909399;
  font-size: 12px;
  flex-shrink: 0;
  margin-right: 12px;
}

.disassemble-row-label {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #606266;
}

.disassemble-row-value {
  flex-shrink: 0;
}

.disassemble-silo-section {
  margin-top: 18px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.disassemble-silo-header {
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  gap: 8px;
}

.disassemble-silo-header i {
  color: #909399;
}

.disassemble-silo-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 14px;
  border-bottom: 1px solid #f2f3f5;
  font-size: 13px;
}

.disassemble-silo-row:last-child {
  border-bottom: none;
}

.disassemble-silo-name {
  color: #303133;
  font-weight: 500;
}

.disassemble-silo-plant {
  font-weight: 600;
  color: #606266;
}

.disassemble-silo-sep {
  font-weight: 400;
  color: #c0c4cc;
}

.disassemble-silo-kg {
  color: #606266;
  font-size: 13px;
}

.disassemble-silo-arrow {
  font-size: 10px;
  margin-right: 6px;
  color: #909399;
}

.disassemble-silo-mismatch {
  background: #fef0f0 !important;
  border-left: 3px solid #f56c6c;
  padding-left: 11px !important;
}

.disassemble-capacity-alert {
  margin-top: 12px;
}

.disassemble-silo-capacity-warn.disassemble-silo-row {
  border-left: 3px solid #f56c6c;
  padding-left: 11px !important;
  background: #fff7f7 !important;
}

.disassemble-silo-capacity-inline {
  width: 100%;
  font-size: 12px;
  color: #c03639;
  margin-top: 6px;
  line-height: 1.4;
}

.disassemble-silo-capacity-inline .fa-ban {
  margin-right: 6px;
}

.text-warning {
  color: #e6a23c !important;
}

.text-warning:hover {
  color: #cf8a15 !important;
}
</style>

